import type { IconSvgObject } from './types';

const StrategyIcon: IconSvgObject = [
  ["path", { d: "M18 11.5L21 8M21 8L18 5M21 8C3 8 3 21 3 21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["circle", { cx: "5.5", cy: "5.5", r: "2.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M13 21L18 16M18 21L13 16", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default StrategyIcon;
